import { useTaskRealtimeSync } from '@/features/tasks/hooks/useTaskRealtimeSync';

/** Mounts Socket.IO task sync while the user is authenticated. */
export function TaskRealtimeBridge() {
  useTaskRealtimeSync();
  return null;
}
